import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    FormControl,
    FormGroup,
    REACTIVE_FORM_DIRECTIVES,
    Validators
} from "@angular/forms";
import {FILE_UPLOAD_DIRECTIVES, FileUploader} from "ng2-file-upload";
import {ClientService} from "../../service/client.service";
import {SendActPayReceiptForm} from "../../domain/sendActPayReceiptForm";
import {DEFAULT_ERROR_MESSAGES, FILE_MAX_SIZE, VALID_MIME_TYPES} from "../../validators/validators";
import {Observable} from "rxjs/Observable";
import {Infraction} from "../../domain/infraction";

@Component({
    selector: 'client-pay-receipt',
    template: require('./payReceipt.component.html'),
    styles: [require('./payReceipt.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [FORM_PROVIDERS]
})
export class PayReceiptComponent implements OnInit {

    @Output() close = new EventEmitter();

    public successMessage: string;
    public errorMessage: string;
    public loading: boolean;
    public errorMessages: any;

    public form: FormGroup;

    public sendActPayReceipt: SendActPayReceiptForm;
    public uploaderActPayReceipt: FileUploader;
    public hasActPayReceiptDropZoneOver: boolean;

    public infractions: Infraction[];

    constructor(/*private loginService:LoginService,*/
                private clientService: ClientService) {
        this.init();
    }

    private init(): void {
        this.loading = false;
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.sendActPayReceipt = new SendActPayReceiptForm();
        this.uploaderActPayReceipt = new FileUploader({});
        this.hasActPayReceiptDropZoneOver = false;

        this.infractions = [];
    }

    public ngOnInit() {
        /*let userLogged = this.loginService.getUserLogged();*/
        this.createFormGroup();

        this.uploaderActPayReceipt = new FileUploader({
            url: 'client/uploadActPayReceipt',
            allowedMimeType: VALID_MIME_TYPES,
            autoUpload: true,
            maxFileSize: FILE_MAX_SIZE,
        });

        this.getData();
    }

    private createFormGroup(): void {

        this.form = new FormGroup({
            actNumber: new FormControl('', [Validators.required]),
            comments: new FormControl()
        });
    }

    private getData(): void {
        this.loading = true;

        let forkTasks: Observable<any>[] = [];
        forkTasks.push(this.clientService.getInfractionActNumbers());
        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los datos de infracción.');
            });
    }

    private setData(data: any[]): void {
        this.loading = false;

        this.infractions = data[0];
    }

    public send(): void {
        this.loading = true;
        this.clearMessages();
        this.clientService.sendActPayReceipt(this.sendActPayReceipt).subscribe(
            () => {
                this.loading = false;
                this.successMessage = 'El comprobante se envió con éxito.';
                this.clearInputs();
            },
            () => {
                this.bindError('Ocurrió un error al enviar el comprobante.');
            });
    }

    private clearInputs(): void {
        this.sendActPayReceipt = new SendActPayReceiptForm();
        this.uploaderActPayReceipt.clearQueue();
    }

    public removeActPayReceiptFromQuee(item: any): void {
        this.clientService.deleteTempActPayReceipt().subscribe(
            (result) => this.uploaderActPayReceipt.clearQueue(),
            () => {
                this.bindError('Ocurrió un error al remover el comprobante.')
            });
    }

    public fileOverActPayReceipt(e: any): void {
        this.hasActPayReceiptDropZoneOver = e;
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }

    private clearMessages(): void {
        this.successMessage = null;
        this.errorMessage = null;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/client/payReceipt/payReceipt.component.ts
 **/